import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router, RouterLinkActive } from '@angular/router'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { DatePickerComponent, KENDO_DATEPICKER } from '@progress/kendo-angular-dateinputs'
import { ComboBoxComponent, DropDownFilterSettings, DropDownListComponent, FilterDirective, KENDO_DROPDOWNS, MultiSelectComponent } from '@progress/kendo-angular-dropdowns'
import * as CryptoJS from 'crypto-js'
import { catchError, delay, EMPTY, forkJoin, of, Subscription } from 'rxjs'
import { distinctUntilChanged, startWith, switchMap, tap } from 'rxjs/operators'
import { environment } from '../../../environments/environment'

import { NgClass, NgFor, NgIf } from '@angular/common'
import { NgIcon, provideIcons } from '@ng-icons/core'
import {
  heroBuildingOffice2,
  heroCalendarDays,
  heroChevronDown,
  heroChevronRight,
  heroCurrencyDollar,
  heroDocumentText,
  heroExclamationCircle,
  heroFlag,
  heroFolder,
  heroHandRaised,
  heroIdentification,
  heroMapPin,
  heroPencilSquare,
  heroUser
} from '@ng-icons/heroicons/outline'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS, WindowCloseResult, WindowComponent, WindowRef, WindowService } from '@progress/kendo-angular-dialog'
import { KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_CHECKBOX, KENDO_INPUTS, KENDO_NUMERICTEXTBOX, MaskedTextBoxComponent, NumericTextBoxComponent, RadioButtonDirective, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { KENDO_LABEL } from '@progress/kendo-angular-label'
import { ToastrService } from 'ngx-toastr'
import { ClientServices } from '../../@theme/services/clients.service'
import { RepServices } from '../../@theme/services/replist.service'
import { TransactionsServices } from '../../@theme/services/transactions.service'
import { TypesServices } from '../../@theme/services/typeslist.service'
import { MiddlemanService } from '../../auth/services/Middleman.service'
import { FilemanagerComponent } from '../FileManager/filemanager.component'
import { PHONE_MASK, toPhoneDigits } from '../../@theme/pipes/phone.pipe'
type NebularStatus = 'primary' | 'success' | 'info' | 'warning' | 'danger' | 'basic' | 'control';
@Component({
  selector: 'gd-account',
  styleUrls: ['./addAccounts.component.css'],
  templateUrl: './addAccounts.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    WindowComponent,
    NgFor,
    RouterLinkActive,
    NgClass,
    ComboBoxComponent,
    FilterDirective,
    RadioButtonDirective,
    TextBoxDirective,
    MaskedTextBoxComponent,
    KENDO_NUMERICTEXTBOX,
    KENDO_CHECKBOX,
    KENDO_LABEL,
    KENDO_DATEPICKER,
    KENDO_BUTTONS,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS, KENDO_BUTTONS,
    NgIcon
  ],
  providers: [
    provideIcons({
      heroUser,
      heroExclamationCircle,
      heroDocumentText,
      heroPencilSquare,
      heroIdentification,
      heroCurrencyDollar,
      heroHandRaised,
      heroCalendarDays,
      heroBuildingOffice2,
      heroFlag,
      heroMapPin,
      heroChevronDown,
      heroChevronRight,
      heroFolder
    })
  ]
})
export class AddAccountsviewComponent implements OnInit, AfterViewChecked, OnDestroy {
  public returnTransactionUrl: string | null = null
  public isSameAddressControl: UntypedFormControl = new UntypedFormControl(
    false,
  )
  dataReasonlist: Array<any> = []
  /*    [
      { reasonId: 1, reasondescription: 'Client Changed Broker Dealer/Rep' },
      { reasonId: 2, reasondescription: 'Client Requested' },
      { reasonId: 3, reasondescription: 'Client(s) Deceased' },
      { reasonId: 4, reasondescription: 'Account(s) Liquidated' },
      { reasonId: 5, reasondescription: 'Duplicate Account' },
      { reasonId: 6, reasondescription: 'Other' }
    ]; */
  selectedReasonId: number | null = null;
  virtual = {
    itemHeight: 26
  };
  @ViewChild('multiselect', { static: false })
  public multiselect: MultiSelectComponent
  @ViewChild('inputControlDropdownlist', { static: true })
  public inputControlDropdownlist: DropDownListComponent
  @Output() openEvent: EventEmitter<any> = new EventEmitter()
  @ViewChild('myname', { static: false }) input: ElementRef
  @ViewChild('maskvalue', { static: false }) maskvalue: ElementRef
  @ViewChild('annualIncFrom', { static: false }) annualIncFrom: NumericTextBoxComponent
  // True while the Date of Account Form datepicker (incl. its popup) holds focus.
  private dateFormActive = false
  private dateFormPicker: DatePickerComponent | null = null
  public Accountstatus: string;
  public checkTxId: boolean = false;
  public TxIdGood: boolean = false;
  public TxIdExist: boolean = false;
  public editaccountlist: any[] = []
  private getClientId: number
  private getRepsId: number
  private paramValueinsert: number
  public submitdisable: boolean
  private getRepId: number
  private roleString: string
  private str: string
  private cit: string
  private sta: string
  private zip: string
  public Msecondary = false
  public maskValidation = false
  public copyfields = false
  public focusedDateAccountform: Date = new Date()
  public focusedDOBDate: Date = new Date('1/5/2005')
  public focusedDOBDatesecond: Date = new Date()
  public calculatedPrimaryAge: string
  public calculatedSecondaryAge: string
  public queryupdate = false;
  public showAccountFiles = false
  public windowRef: WindowRef
  private overlayEl!: HTMLDivElement
  public showTransactionPicker = false
  public loadingTransactionList = false
  public transactionFileList: any[] = []
  public formatOptions: any = {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'name',
    prefix: '',
  }
  private addTransactionAfterSubmit = false
  private values: Date = new Date()
  private valuesDOB: Date = new Date()
  private valuessecondary: Date = new Date()
  private valuessecondarymature: Date = new Date()
  public value = ''
  private subscription: Subscription
  private rolesplit: string
  private rolesplitfirst: string
  private splitvalue: string[]
  public advisorrole: boolean = false
  public headtitlePopup: any = []
  public opened = false
  public taxList: any = []

  // 529 (6) and UTMA/UGMA (5): a matching Tax ID is only a soft warning with a
  // link to the existing account -- the user may still save. All other account
  // types keep the hard stop.
  readonly softDupTypes = [5, 6]
  primaryDupMatches: any[] = []
  secondaryDupMatches: any[] = []
  showDupDialog = false
  private pendingSubmitActive = true
  public autoCorrect = true
  public min: Date = new Date(1917, 0, 1)
  public max: Date = new Date(2010, 11, 31)
  public age: number
  public name = ''
  public style1: boolean
  public HeaderInfo: string
  public FirstNamecompany: string
  public displaysecondaryck: boolean
  public displayInfo: boolean
  public Shownewfields: boolean = false;
  public secondaryForm: boolean
  public accountInfoExpanded: boolean = true // Auto-expand Account Information card
  public secondaryheader: string
  public secondarymainheader: string
  public showtaxinfo: boolean
  public annualbool: boolean
  public annualboolvalue: boolean
  public networthbool: boolean
  public networthboolvalue: boolean
  public Liquidbool: boolean
  public Liquidboolvalue: boolean
  public riskbool: boolean
  public hasval: boolean = true;
  public riskvalue: boolean
  public investbool: boolean
  public investvalue: boolean
  public liquiddropbool: boolean
  public liquiddropvalue: boolean
  public timehorizonbool: boolean
  public timehorizonboolvalue: boolean
  public advisebool: boolean
  public adviseboolvalue: boolean
  public style0: boolean
  public style00: boolean
  public style2: boolean
  public style3: boolean
  public style4: boolean
  public style5: boolean
  public style6: boolean
  public fname: boolean
  public fnamevalue: boolean
  public lname: boolean
  public lnamevalue: boolean
  public dobbool: boolean
  public dobboolvalue: boolean
  public addrboolvalue: boolean
  private boolValue = false
  public addrbool: boolean
  public ctybool: boolean
  public ctyboolvalue: boolean
  public statebool: boolean
  public emailbool: boolean
  public emailboolvalue: boolean
  public mobilebool: boolean
  public mobileboolvalue: boolean
  public statevalue: boolean
  public zipbool: boolean
  public zipvalue: boolean
  public signa: boolean
  public signahasvalue: boolean
  public dtebool: boolean
  public dtevalue: boolean
  public displaytext: string
  public investmin = 1950
  public investmax = 2040
  public SeletedList: Array<string> = ['On File', 'Submitted', 'Missing']
  faCoffee = faCoffee
  public mask = '###-##-####'
  public secondarymask = '###-##-####'
  public mobileMask = PHONE_MASK
  public zipcodelist: Array<string> = ['#####-####', '#####']
  public zipcodestring: string
  public zipcodelist2: Array<string> = ['#####-####', '#####']
  public zipcodestring2: string
  private encPassword: string
  public newloginForm: UntypedFormGroup
  public events: string[] = []
  public listItems: Array<any> = []
  public clientlisting: Array<any> = []
  public listClientTypes: Array<any> = []
  public listStates: Array<any> = []
  public InvestObjLists: Array<any> = []
  public InvestObjnwewLists: Array<any> = []
  public LiquidityNeedsLists: Array<any> = []
  public TimeHorizonLists: Array<any> = []
  public Taxmasklist: Array<string> = ['##-#######', '###-##-####']
  public data: Array<any>
  public masklistlisting: Array<any> = []
  public text: string
  public paramgetRepId: any
  public loader: boolean
  public Tr1: boolean
  public liqquidloading: boolean
  public timezoneloading: boolean
  public loaderType: boolean
  public loaderstatelist: boolean
  public investloading: boolean
  public investobjloading: boolean
  public repdata: any
  public accountname: string
  public selectedStatus: Array<string> = [
    'basic',
    'primary',
    'danger',
    'success',
    'info',
    'warning',
  ]
  openOpenAccount: boolean;
  openDeleteAccount: boolean
  deleteAccountUserClose: boolean
  public statusIndex0: string
  public statusIndex1: string
  public statusIndex2: string
  public showmessage0: boolean
  public showmessage1: boolean
  public showmessage2: boolean
  public Rolerep = false;
  public RoleAdvisor: boolean
  public Roleperms: boolean
  private rparam: any
  public hideclientreplist: boolean
  public Deletebuttonview: boolean
  public get numValue(): number {
    return +this.value
  }
  form = new UntypedFormGroup({
    reasonselect: new UntypedFormControl(null)
  });
  profileForm = new UntypedFormGroup({
    ClientId: new UntypedFormControl(),
    FirstName: new UntypedFormControl(''),
    MiddleName: new UntypedFormControl(''),
    LastName: new UntypedFormControl(''),
    RepId: new UntypedFormControl(),
    ClientTypeId: new UntypedFormControl(),
    AccountName: new UntypedFormControl(''),
    TaxId: new UntypedFormControl(''),
    InsExp: new UntypedFormControl(''),
    DOB: new UntypedFormControl(''),
    Address1: new UntypedFormControl(''),
    Address2: new UntypedFormControl(''),
    City: new UntypedFormControl(''),
    State: new UntypedFormControl(''),
    ZipCode: new UntypedFormControl(''),
    EmailAddress: new UntypedFormControl(''),
    RepSignature: new UntypedFormControl(false),
    AssociatedPerson: new UntypedFormControl(''),
    AssociatedAccount: new UntypedFormControl(''),
    CopyOfDl: new UntypedFormControl(''),
    NewAccountForm: new UntypedFormControl(''),
    DateOfNewAccountForm: new UntypedFormControl(''),
    AnnualIncFrom: new UntypedFormControl(''),
    AnnualIncTo: new UntypedFormControl(''),
    NetWorthTo: new UntypedFormControl(''),
    NetWorthFrom: new UntypedFormControl(''),
    LiquidNWFrom: new UntypedFormControl(''),
    LiquidNWTo: new UntypedFormControl(''),
    InvObjectiveId: new UntypedFormControl(''),
    LiquidityNeedsList: new UntypedFormControl(''),
    TimeHorizonList: new UntypedFormControl(''),
    EquitiesExp: new UntypedFormControl(''),
    FixedIncExp: new UntypedFormControl(''),
    OptionsExp: new UntypedFormControl(''),
    MutFundsExp: new UntypedFormControl(''),
    Etfexp: new UntypedFormControl(''),
    RealEstateExp: new UntypedFormControl(''),
    InsuranceExp: new UntypedFormControl(''),
    Vaexp: new UntypedFormControl(''),
    FixedAnnExp: new UntypedFormControl(''),
    PrecMetExp: new UntypedFormControl(''),
    CommExp: new UntypedFormControl(''),
    OtherExp: new UntypedFormControl(''),
    OtherExpDesc: new UntypedFormControl(''),
    Comment: new UntypedFormControl(''),
    Uitexp: new UntypedFormControl(''),
    cbCopyToSecondary: new UntypedFormControl(''),
    CompanyName: new UntypedFormControl(''),
    SecondaryFirstName: new UntypedFormControl(''),
    SecondaryMiddleName: new UntypedFormControl(''),
    SecondaryLastName: new UntypedFormControl(''),
   SecondaryEmail: new UntypedFormControl(''),
   SecondaryMobile: new UntypedFormControl(''),
    SecondaryTaxID: new UntypedFormControl(''),
    SecondarycopyofDLView: new UntypedFormControl(''),
    SecondaryDOB: new UntypedFormControl(''),
    SecondaryAddress1: new UntypedFormControl(''),
    SecondaryAddress2: new UntypedFormControl(''),
    SecondaryCity: new UntypedFormControl(''),
    SecondaryState: new UntypedFormControl(''),
    SecondaryZipCode: new UntypedFormControl(''),
    AdvisorClient: new UntypedFormControl(false),
    AccountOpen: new UntypedFormControl(true),
    TaxIdmaskId: new UntypedFormControl(''),
    InvestmentTimeHorizonId: new UntypedFormControl(),

  })
  options = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ]
  option
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'startsWith',
  }
  checkValueGreater(field: string) {
    const formValues = this.profileForm.value;
 if (field === 'AnnualInc') {
      const from = formValues.AnnualIncFrom;
      const to = formValues.AnnualIncTo;
      this.showmessage0 = from != null && to != null && to < from;
    } else if (field === 'NetWorth') {
      const from = formValues.NetWorthFrom;
      const to = formValues.NetWorthTo;
      this.showmessage1 = from != null && to != null && to < from;
    } else if (field === 'LiquidNW') {
      const from = formValues.LiquidNWFrom;
      const to = formValues.LiquidNWTo;
      this.showmessage2 = from != null && to != null && to < from;
    }
  }

  /*  public checkvalueGreater(x: number, y: number) {
     if (y === 0) {
       if (x === null) {
         this.showmessage0 = false
         return
       }
       if (x <= this.profileForm.value.AnnualIncFrom) {
         this.showmessage0 = true
       } else {
         this.showmessage0 = false
       }
     }
     if (y === 1) {
       if (x === null) {
         this.showmessage1 = false
         return
       }
       if (x <= this.profileForm.value.NetWorthFrom) {
         this.showmessage1 = true
       } else {
         this.showmessage1 = false
       }
     }
     if (y === 2) {
       if (x === null) {
         this.showmessage2 = false
         return
       }
       if (x <= this.profileForm.value.LiquidNWFrom) {
         this.showmessage2 = true
       } else {
         this.showmessage2 = false
       }
     }
   } */
  public changeFilterOperator(operator: any): void {
    this.filterSettings.operator = operator
  }
  constructor(
    private ur: ClientServices,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private lk: ClientServices,
    private _requestserv: MiddlemanService,
    private router: Router,
    private typ: TypesServices,
    private serv: RepServices,
    private fb: UntypedFormBuilder,
    private windowService: WindowService,
    private transactionService: TransactionsServices,
    // private accountListCache: AccountListCacheService,
  ) {
    this.hideclientreplist = false
    const storageValueReturn =
      localStorage.getItem('rvarietylist') == undefined
        ? ''
        : localStorage.getItem('rvarietylist')
    this.rparam = CryptoJS.AES.decrypt(
      storageValueReturn,
      environment.securepw,
    ).toString(CryptoJS.enc.Utf8)

    const lowerParam = this.rparam.toLowerCase();
    console.log('checkrep=' + JSON.stringify(this.rparam))

    this.Rolerep = this.rparam.toLowerCase() !== 'rep'
    this.RoleAdvisor = decodeURIComponent(lowerParam) === 'advisor principal' ? false : true;
    this.Roleperms = decodeURIComponent(lowerParam) === 'rep' ? false : true;
    this.queryupdate = false
    this.zipcodestring = this.zipcodelist[0]
    this.zipcodestring2 = this.zipcodelist[0]
    this.encPassword = environment.decPassword
    this.showtaxinfo = false
    this.Tr1 = false
    this.HeaderInfo = 'Client Information'
    this.FirstNamecompany = 'First Name'
    this.displayInfo = false
    this.secondaryForm = false
    this.showmessage0 = false
    this.showmessage1 = false
    this.showmessage2 = false
    this.dobbool = true
    this.dobboolvalue = false
    this.style5 = true
    this.style6 = false
    this.style2 = false
    this.style00 = false
    this.style1 = true
    this.style3 = true
    this.style4 = false
    this.fnamevalue = false
    this.fname = true
    this.lnamevalue = false
    this.lname = true
    this.addrboolvalue = false
    this.addrbool = true
    this.ctyboolvalue = false
    this.ctybool = true
    this.statevalue = false
    this.statebool = true
    this.emailbool = true
    this.emailboolvalue = false
    this.mobilebool = true
    this.mobileboolvalue = false
    this.zipbool = true
    this.zipvalue = false
    this.dtevalue = false
    this.dtebool = true
    this.signa = true
    this.signahasvalue = false
    this.submitdisable = false
    if (decodeURIComponent(this.rparam).toLowerCase() === 'advisor principal') {
      this.profileForm = this.fb.group({
        ClientId: [],
        AccountName: ['', Validators.required],
        RepId: ['', Validators.required],
        ClientTypeId: ['', Validators.required],
        FirstName: ['', Validators.required],
        MiddleName: [],
        LastName: ['', Validators.required],
        TaxId: ['', Validators.required],
        Uitexp: [],
        cbCopyToSecondary: [],
        CompanyName: [],
        InsExp: [],
        Address1: [],
        lblCODFaxLink: [],
        Address2: [],
        EmailAddress: [''],
        Mobile: [],
        AssociatedPerson: [],
        AssociatedAccount: [],
        CopyOfDl: [],
        NewAccountForm: [],
        RepSignature: [],
        AnnualIncFrom: [null],
        AnnualIncTo: [null],
        NetWorthFrom: [null],
        NetWorthTo: [null],
        LiquidNWFrom: [null],
        LiquidNWTo: [null],
        InvestmentProfileId: [null],
        InvObjectiveId: [null],
        LiquidityNeedsId: [null],
        InvestmentTimeHorizonId: [null],
        EquitiesExp: [],
        FixedIncExp: [],
        OptionsExp: [],
        MutFundsExp: [],
        Etfexp: [],
        RealEstateExp: [],
        InsuranceExp: [],
        Vaexp: [],
        FixedAnnExp: [],
        PrecMetExp: [],
        CommExp: [],
        OtherExp: [],
        OtherExpDesc: [],
        Comment: [],
        ClientNoteId: [],
        SecondaryFirstName: [],
        SecondaryMiddleName: [],
        SecondaryLastName: [],
             SecondaryEmail: [],
        SecondaryMobile: [],
        SecondaryTaxID: [],
        SecondarycopyofDLView: [],
        SecondaryDOB: [],
        SecondaryAddress1: [],
        SecondaryAddress2: [],
        SecondaryCity: [],
        SecondaryState: [],
        SecondaryZipCode: [],
        AdvisorClient: [],
        TaxIdmaskId: [],
        AccountOpen: new UntypedFormControl(true),
      })
    }
    if (decodeURIComponent(this.rparam).toLowerCase() !== 'advisor principal') {
      this.profileForm = this.fb.group({
        ClientId: [],
        AccountName: ['', Validators.required],
        RepId: ['', Validators.required],
        ClientTypeId: ['', Validators.required],
        FirstName: ['', Validators.required],
        MiddleName: [],
        LastName: ['', Validators.required],
        DOB: ['', Validators.required],
        TaxId: ['', Validators.required],
        InvestmentProfileId: [],
        Uitexp: [],
        cbCopyToSecondary: [],
        CompanyName: [],
        InsExp: [],
        Address1: [],
        lblCODFaxLink: [],
        Address2: [],
        City: [],
        State: [],
        ZipCode: [],
        EmailAddress: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'),
            Validators.minLength(1),
          ]),
        ],
        Mobile: [],
        AssociatedPerson: [],
        AssociatedAccount: [],
        CopyOfDl: [],
        NewAccountForm: [],
        DateOfNewAccountForm: ['', Validators.required],
        RepSignature: [],
        AnnualIncFrom: [],
        AnnualIncTo: [],
        NetWorthTo: [],
        NetWorthFrom: [],
        LiquidNWFrom: [],
        LiquidNWTo: [],
        InvObjectiveId: [],
        LiquidityNeedsId: [],
        InvestmentTimeHorizonId: [],
        EquitiesExp: [],
        FixedIncExp: [],
        OptionsExp: [],
        MutFundsExp: [],
        Etfexp: [],
        RealEstateExp: [],
        InsuranceExp: [],
        Vaexp: [],
        FixedAnnExp: [],
        PrecMetExp: [],
        CommExp: [],
        OtherExp: [],
        OtherExpDesc: [],
        Comment: [],
        ClientNoteId: [],
        SecondaryFirstName: [],
        SecondaryMiddleName: [],
        SecondaryLastName: [],
        SecondaryEmail: [],
        SecondaryMobile: [],
        SecondaryTaxID: [],
        SecondarycopyofDLView: [],
        SecondaryDOB: [],
        SecondaryAddress1: [],
        SecondaryAddress2: [],
        SecondaryCity: [],
        SecondaryState: [],
        SecondaryZipCode: [],
        AdvisorClient: [],
        TaxIdmaskId: [],
        AccountOpen: new UntypedFormControl(true),
      })
    }
    this.data = []
    this.statusIndex0 = this.selectedStatus[2]
    this.statusIndex1 = this.selectedStatus[2]
    this.statusIndex2 = this.selectedStatus[2]
    this.timezoneloading = true
    this.liqquidloading = true
    if (this.route.snapshot.queryParams['Cld']) {
      this.route.queryParams.subscribe((params) => {
        this.getClientId = Number(params['Cld'])
        this.EditTransactionStartMethod(this.getClientId)
        this.queryupdate = true
        this.Deletebuttonview = true
        this.LoadDataAccount()
        this.profileForm.get('ClientId').setValue(this.getClientId)
      })
    } else {
      this.queryupdate = false
    }
  }
  ngAfterViewChecked() {
    if (this.profileForm.value.DOB) {
      this.dobboolvalue = true
      this.dobbool = false
    } else {
      this.dobbool = true
      this.dobboolvalue = false
    }
    if (this.profileForm.value.RepId) {
      this.style0 = false
      this.style00 = true
    } else {
      this.style00 = false
      this.style0 = true
    }
    if (this.profileForm.value.AccountName) {
      this.style1 = false
      this.style2 = true
    } else {
      this.style2 = false
      this.style1 = true
    }
    if (this.profileForm.value.ClientTypeId) {
      this.style5 = false
      this.style6 = true
    } else {
      this.style6 = false
      this.style5 = true
    }
    if (this.profileForm.value.TaxId) {
      this.style4 = true
      this.style3 = false
    } else {
      this.style3 = true
      this.style4 = false
    }
    if (this.profileForm.value.FirstName) {
      this.fname = false
      this.fnamevalue = true
    } else {
      this.fnamevalue = false
      this.fname = true
    }
    if (this.profileForm.value.LastName) {
      this.lname = false
      this.lnamevalue = true
    } else {
      this.lnamevalue = false
      this.lname = true
    }
    if (this.profileForm.value.Address1) {
      this.addrbool = false
      this.addrboolvalue = true
    } else {
      this.addrbool = true
      this.addrboolvalue = false
    }
    if (this.profileForm.value.City) {
      this.ctybool = false
      this.ctyboolvalue = true
    } else {
      this.ctybool = true
      this.ctyboolvalue = false
    }
    if (this.profileForm.value.State) {
      this.statebool = false
      this.statevalue = true
    } else {
      this.statebool = true
      this.statevalue = false
    }
     if (this.profileForm.value.Mobile) {
      this.mobilebool = false
      this.mobilebool = true
    } else {
      this.mobilebool = true
      this.mobilebool = false
    }
     if (this.profileForm.value.Email) {
      this.emailbool = true
      this.emailboolvalue = true
    } else {
      this.emailbool = false
      this.emailboolvalue = false
    }
    if (this.profileForm.value.ZipCode) {
      this.zipbool = false
      this.zipvalue = true
    } else {
      this.zipbool = true
      this.zipvalue = false
    }
    /*  if (this.profileForm.value.City !== null) { ctybool
       this.ctybool = false
       this.ctyboolvalue = true
     } else {
       this.ctyboolvalue = false
       this.ctybool = true
     }
     if (this.profileForm.value.State !== null) {
       this.statebool = false
       this.statevalue = true
     } else {
       this.statevalue = false
       this.statebool = true
     }
     if (this.profileForm.value.ZipCode !== null) {
       if (this.profileForm.value.ZipCode.trim().length > 4) {
         this.zipbool = false
         this.zipvalue = true
       } else {
         this.zipbool = true
         this.zipvalue = false
       }
     } */
    if (this.profileForm.value.DateOfNewAccountForm !== '') {
      this.dtebool = false
      this.dtevalue = true
    } else {
      this.dtevalue = false
      this.dtebool = true
    }
    if (this.profileForm.value.RepSignature !== null) {
      this.signa = false
      this.signahasvalue = true
    } else {
      this.signa = true
      this.signahasvalue = false
    }
    if (
      this.profileForm.value.AnnualIncFrom !== null &&
      this.profileForm.value.AnnualIncTo !== null
    ) {
      this.annualbool = false
      this.annualboolvalue = true
    } else {
      this.annualboolvalue = false
      this.annualbool = true
    }
    if (
      this.profileForm.value.NetWorthFrom !== null &&
      this.profileForm.value.NetWorthTo !== null
    ) {
      this.networthbool = false
      this.networthboolvalue = true
    } else {
      this.networthboolvalue = false
      this.networthbool = true
    }
    if (
      this.profileForm.value.LiquidNWFrom !== null &&
      this.profileForm.value.LiquidNWTo !== null
    ) {
      this.Liquidbool = false
      this.Liquidboolvalue = true
    } else {
      this.Liquidboolvalue = false
      this.Liquidbool = true
    }
    if (this.profileForm.value.InvestmentProfileId !== null) {
      this.riskbool = false
      this.riskvalue = true
    } else {
      this.riskvalue = false
      this.riskbool = true
    }
    if (this.profileForm.value.InvObjectiveId !== null) {
      this.investbool = false
      this.investvalue = true
    } else {
      this.investvalue = false
      this.investbool = true
    }
    if (this.profileForm.value.LiquidityNeedsId !== null) {
      this.liquiddropbool = false
      this.liquiddropvalue = true
    } else {
      this.liquiddropvalue = false
      this.liquiddropbool = true
    }
    if (this.profileForm.value.InvestmentTimeHorizonId !== null) {
      this.timehorizonbool = false
      this.timehorizonboolvalue = true
    } else {
      this.timehorizonboolvalue = false
      this.timehorizonbool = true
    }
    if (this.profileForm.value.AdvisorClient !== null) {
      this.advisebool = false
      this.adviseboolvalue = true
    } else {
      this.adviseboolvalue = false
      this.advisebool = true
    }
    const mobileValue = this.profileForm.value.Mobile?.replace(/[\s()_-]/g, '');
    if (mobileValue && mobileValue.length > 0) {
      this.mobilebool = false
      this.mobileboolvalue = true
    } else {
      this.mobileboolvalue = false
      this.mobilebool = true
    }
    if (this.profileForm.value.EmailAddress && this.profileForm.value.EmailAddress !== '') {
      this.emailbool = false
      this.emailboolvalue = true
    } else {
      this.emailboolvalue = false
      this.emailbool = true
    }
    this.maskValidation = false
    
    this.cdr.detectChanges()
  }
  public accountDateDisabledDates = (date: Date): boolean => {
    return Date.now() - date.getTime() < 0
  }
  /* click open FileManager popup for one transaction on this account.
     Unlike the Transaction screen there is no single transaction in context here,
     so the client's transactions are listed and the user picks one. */
  viewFilestransaction(): void {
    // The lookup is a round trip, so ignore repeat clicks while it is in flight.
    if (this.loadingTransactionList) {
      return
    }
    const repId = this.profileForm.value.RepId
    if (!repId) {
      this.toastr.warning(
        'This account is still loading. Please try again in a moment.',
        'File Manager',
      )
      return
    }

    this.loadingTransactionList = true
    // RepId is sent explicitly so the API does not fall back to the signed-in
    // user's own rep setting. The client is joined on its rep, so this is the
    // same rep the account is under. Dates are null to get the full history.
    const param = {
      ClientId: Number(this.getClientId),
      RepId: Number(repId),
      BranchNumber: '',
      repCode: '',
      BlotterId: null,
      ClientName: null,
      AccountName: null,
      AccountNumber: null,
      StatusTypeId: null,
      SubmittedStartDate: null,
      SubmittedEndDate: null,
      ApprovalStartDate: null,
      ApprovalEndDate: null,
    }
    this.transactionService.getTransactionResults(param).subscribe({
      next: (response) => {
        this.loadingTransactionList = false
        const results = response ?? []
        if (results.length === 0) {
          this.toastr.info(
            'This account has no transactions to show files for.',
            'File Manager',
          )
          return
        }
        // Nothing to choose between when there is only one.
        if (results.length === 1) {
          this.openTransactionFiles(results[0].blotterId)
          return
        }
        this.transactionFileList = results.map((t: any) => ({
          blotterId: t.blotterId,
          label: this.buildTransactionLabel(t),
        }))
        this.showTransactionPicker = true
        this.cdr.detectChanges()
      },
      error: () => {
        this.loadingTransactionList = false
        this.toastr.error(
          'Could not load the transactions for this account.',
          'File Manager',
        )
      },
    })
  }
  private buildTransactionLabel(t: any): string {
    const received = t.dateReceived
      ? new Date(t.dateReceived).toLocaleDateString()
      : 'No date'
    const parts = [
      'Trans ID: ' + t.blotterId,
      received,
      t.transactionTypeDesc,
      t.productTypeDesc || t.productName,
      t.accountNumber,
      t.statusTypeDesc,
    ]
    return parts.filter((p) => p).join(' - ')
  }
  public closeTransactionPicker(): void {
    this.showTransactionPicker = false
  }
  /* transaction-scoped listing: the transaction's own folder plus the standard
     Account Forms / Correspondence / Drivers License / Other folders */
  openTransactionFiles(blotterId: number): void {
    this.showTransactionPicker = false
    const repId = this.profileForm.value.RepId

    if (this.windowRef) {
      this.windowRef.close()
    }

    this.overlayEl = document.createElement('div')
    this.overlayEl.classList.add('k-overlay')
    document.body.appendChild(this.overlayEl)

    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: FilemanagerComponent,
      width: 1000,
      height: 675,
    })

    this.windowRef.result.subscribe(() => this.destroyOverlay())
    const fileManager = this.windowRef.content.instance

    fileManager.outputClientId = String(this.getClientId)
    fileManager.outputrepId = String(repId)
    fileManager.clientName = this.buildClientName()
    fileManager.outquery = 'blotterId'
    fileManager.viewallblot = ''
    fileManager.blotterId = String(blotterId)

    fileManager.getFolderFiles()

    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
      }
    })
  }
  private buildClientName(): string {
    const LastName = this.profileForm.value.LastName
    const FirstName = this.profileForm.value.FirstName
    return LastName && LastName.length > 0
      ? LastName + ', ' + FirstName
      : FirstName
  }
  /* click open FileManager popup for every file on this account */
  viewFilesaccount(): void {
    const repId = this.profileForm.value.RepId
    // repId is a literal folder path segment on the server, so an empty one would
    // resolve - and auto-create - the wrong tree. The account load is async, so a
    // very early click can land before RepId is populated.
    if (!repId) {
      this.toastr.warning(
        'This account is still loading. Please try again in a moment.',
        'File Manager',
      )
      return
    }

    // If windowRef is not null, close the window before opening a new one
    if (this.windowRef) {
      this.windowRef.close()
    }

    this.overlayEl = document.createElement('div')
    this.overlayEl.classList.add('k-overlay')
    document.body.appendChild(this.overlayEl)

    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: FilemanagerComponent,
      width: 1000,
      height: 675,
    })

    this.windowRef.result.subscribe(() => this.destroyOverlay())
    const fileManager = this.windowRef.content.instance

    fileManager.outputClientId = String(this.getClientId)
    fileManager.outputrepId = String(repId)
    fileManager.clientName = this.buildClientName()
    fileManager.viewallblot = ''
    // viewaccountsscreen is what widens the listing to every folder on the account,
    // including one per transaction. blotterId is deliberately left unset - the API
    // keys off the literal string 'undefined' to mean "no transaction".
    fileManager.viewaccountsscreen = true

    // Sets windowRef to null when window is closed
    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
      }
    })
  }
  private destroyOverlay(): void {
    if (this.overlayEl && document.body.contains(this.overlayEl)) {
      document.body.removeChild(this.overlayEl)
    }
  }
  ngOnDestroy() {
    // Leaving the page with the file manager open would otherwise strand the
    // k-overlay over the whole app.
    if (this.windowRef) {
      this.windowRef.close()
      this.windowRef = null
    }
    this.destroyOverlay()
  }
  // REP dropdown / delete permissions follow the role. Only Rolerep and Roleperms
  // are re-applied: RoleAdvisor also decides the form's validators, which are
  // built once in the constructor.
  private setRoleFlags(roleName: string) {
    const role = decodeURIComponent(roleName || '').trim().toLowerCase()
    if (!role) {
      return
    }
    this.Rolerep = role !== 'rep'
    this.Roleperms = role !== 'rep'
  }

  ngOnInit() {

    // Removed deprecated usage of routeReuseStrategy
    // Configure RouteReuseStrategy in the module's providers if needed
    // If we arrived here from a transaction (AccountName link carries transactionId),
    // remember the stored transaction URL so we can offer a "Back to Transaction" button
    // and auto-return after save.
    if (this.route.snapshot.queryParams['transactionId']) {
      this.returnTransactionUrl = sessionStorage.getItem('returnToTransactionUrl')
    }
    if (this.route.snapshot.queryParams['Cld']) {
      this.route.queryParams.subscribe((c) => {
        this.queryupdate = true
        this.Deletebuttonview = true
        this.getAccountComments(c['Cld'])
      })
    } else {
      this.queryupdate = false
    }
    // File links only make sense for an account that already exists, and only on the
    // edit-account route. add-account?Cld= (advisors / Transaction page) is excluded.
    this.showAccountFiles =
      this.route.snapshot.routeConfig?.path === 'AccountForm/edit-account' &&
      !!this.route.snapshot.queryParams['Cld']
    this.subscription = this._requestserv.notifyObservable$.subscribe((res) => {
      const storageValue =
        localStorage.getItem('rvarietylist') == undefined
          ? ''
          : localStorage.getItem('rvarietylist')
      const paramTR = CryptoJS.AES.decrypt(
        storageValue,
        environment.securepw,
      ).toString(CryptoJS.enc.Utf8)
      const checkParamTR = decodeURI(paramTR)
      this.roleString = checkParamTR
      // notifyClear can emit null/'' (timeout, header init) - nothing to apply yet
      if (!res) {
        return
      }
      this.splitvalue = res.split('|')
      this.rolesplit = this.splitvalue[0]
      this.rolesplitfirst = this.splitvalue[1]
      this.roleString = this.rolesplit
      // The constructor may have run before the role was stored (cold load),
      // leaving the REP dropdown hidden; re-apply the role flags now.
      this.setRoleFlags(this.rolesplit)
      const paramTN = CryptoJS.AES.encrypt(
        encodeURI(this.rolesplit),
        environment.securepw,
      ).toString()
      const paramviewRoleTN = CryptoJS.AES.encrypt(
        encodeURI(this.rolesplitfirst),
        environment.securepw,
      ).toString()
      localStorage.setItem('rvarietylist', paramTN)
      localStorage.setItem('rrolelisted', paramviewRoleTN)
      this.GetrepList()
      this.GetActiveStatesList()
      this.GetInvestmentProfileTypes()
      this.getAccountType()
      this.GetTimeZoneTypes()
      this.GetLiquidTypes()
      this.GetMaskList()

      if (
        this.rolesplit === 'ADVISOR PRINCIPAL' ||
        this.rolesplit === 'ADVISOR USER'
      ) {
        this.advisorrole = true
      } else {
        this.advisorrole = false
      }
      this.cdr.detectChanges();
    })
    const storageValueReturn =
      localStorage.getItem('rvarietylist') == undefined
        ? ''
        : localStorage.getItem('rvarietylist')
    const paramT = CryptoJS.AES.decrypt(
      storageValueReturn,
      environment.securepw,
    ).toString(CryptoJS.enc.Utf8)
    const checkParamT = decodeURI(paramT)
    this.roleString = checkParamT
    // Removed an unused decrypt of clRepid/rpd here: initCurrentUser() deletes
    // 'rpd' while /settings/current is in flight, and decrypt(null) threw,
    // aborting ngOnInit before any dropdown list was requested.

    this.GetrepList()
    this.GetActiveStatesList()
    this.GetInvestmentProfileTypes()
    this.getAccountType()
    this.GetTimeZoneTypes()
    this.GetLiquidTypes()
    this.GetMaskList()
    if (decodeURIComponent(this.rparam).toLowerCase() === 'advisor principal') {
      setTimeout(
        () => this.profileForm.get("ClientTypeId").setValue(Number(1)),
        1000,
      )
    }
    this.profileForm.get('TaxIdmaskId').setValue(1)
    if (this.route.snapshot.queryParams['reid']) {
      this.route.queryParams.subscribe((params) => {
        const getclient = CryptoJS.AES.decrypt(
          params['reid'].trim(),
          environment.securepw.trim(),
        ).toString(CryptoJS.enc.Utf8)
        const checkParamTf = decodeURI(getclient)
        this.getRepsId = Number(checkParamTf)
      })
    }
    if (!this.route.snapshot.queryParams['Cld']) {
      if (Number(this.getRepId) === 0) {
        this.getRepId = Number(localStorage.getItem('rpd'))
      }
      setTimeout(
        () => this.profileForm.get('RepId').setValue(Number(this.getRepsId)),
        7000,
      )
    }
    this.pushCopyData()
    if (checkParamT === 'ADVISOR PRINCIPAL' || checkParamT === 'ADVISOR USER') {
      this.advisorrole = true
      const getval = 'true'.toString()
      this.profileForm.get('AdvisorClient').setValue(getval)
      return;
    }
   else {
      this.advisorrole = false
      const getval = 'false'.toString()
      this.profileForm.get('AdvisorClient').setValue(getval)
      return;
    }
  }

  private getreturn() {
    this.statusIndex0 = this.selectedStatus[3]
  }
  private getreturn2() {
    this.statusIndex0 = this.selectedStatus[2]
  }
  private getreturn3() {
    this.statusIndex1 = this.selectedStatus[3]
  }
  private getreturn4() {
    this.statusIndex1 = this.selectedStatus[2]
  }
  private getreturn5() {
    this.statusIndex2 = this.selectedStatus[3]
  }
  private getreturn6() {
    this.statusIndex2 = this.selectedStatus[2]
  }
  public selectionStateChange(event: any) {
    if (event.value !== undefined) {
      this.statebool = false
      this.statevalue = true
      return
    } else {
      this.statevalue = false
      this.statebool = true
      return
    }
  }
  public selectionStateChange2(event: any) {
    if (event.value !== undefined) {
      this.statebool = false
      this.statevalue = true
      return
    } else {
      this.statevalue = false
      this.statebool = true
      return
    }
  }
  public selectchangevalues() {
    if (this.rparam.toLowerCase() === 'rep'.toLowerCase()) {
      if (this.profileForm.value.RepId) {
        this.ur.getaccountlistbyRepId().subscribe((response) => {
          this.clientlisting = response
          if (this.clientlisting.length > 0) {
            this.hideclientreplist = true
          }
        })
      }
    } else {
      const repId = { repId: this.profileForm.value.RepId }
      if (this.profileForm.value.RepId) {
        this.ur.getaccountlistbyRepIdselected(repId).subscribe((response) => {
          this.clientlisting = response
          if (this.clientlisting.length > 0) {
            this.hideclientreplist = true
          }
        })
      }
    }
  }
  public selectionChange(drop: any) {
    //   drop.toggle(true)
    this.clearSoftDupState()
    this.Tr1 = false
    this.FirstNamecompany = 'First Name'
    this.secondaryheader = 'Copy Trust Address to Trustee Address'
    this.HeaderInfo = 'Client Information'
    this.displayInfo = false
    this.setLastNameRequired(true)
    this.secondaryForm = false
    this.style5 = false
    this.style6 = true

    // Restore email validators for all types (will be cleared for clientTypeId 5)
    if (decodeURIComponent(this.rparam).toLowerCase() !== 'advisor principal') {
      this.profileForm.get('EmailAddress').setValidators(
        Validators.compose([
          Validators.required,
          Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'),
          Validators.minLength(1),
        ])
      );
      this.hasval = false;
      this.profileForm.get('EmailAddress').updateValueAndValidity();
    }
    /**
     * Selection Rep Id must exists in order to retrieve
     */
    if (this.rparam.toLowerCase() === 'rep'.toLowerCase()) {
      if (this.profileForm.value.RepId) {
        this.ur.getaccountlistbyRepId().subscribe((response) => {
          this.clientlisting = response
          if (this.clientlisting.length > 0) {
            this.hideclientreplist = true
          }
        })
      }
    } else {
      const repId = { repId: this.profileForm.value.RepId }
      if (this.profileForm.value.RepId) {
        this.ur.getaccountlistbyRepIdselected(repId).subscribe((response) => {
          this.clientlisting = response
          if (this.clientlisting.length > 0) {
            this.hideclientreplist = true
          }
        })
      }
    }
    this.profileForm.get('TaxIdmaskId').setValue(1)

    if (drop.clientTypeId === 7 || drop.clientTypeId === 8) {
      this.mask = '##-#######'
      this.profileForm.get('TaxIdmaskId').setValue(2)
    } else {
      this.mask = '###-##-####'
      this.profileForm.get('TaxIdmaskId').setValue(1)
    }

    if (drop.clientTypeId == 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - INDV 401K</span>'
    }
    if (drop.clientTypeId == 1) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - INDV</span>'

      return
    }
    if (drop.clientTypeId == 2) {
      this.HeaderInfo = 'Primary Client Information'
      this.secondaryheader =
        'Copy Primary Client Address to Secondary Client Address'
      this.secondarymainheader = 'Secondary Client Information'
      this.Tr1 = true
      this.Msecondary = true
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.displaysecondaryck = false
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN L. & JANE P. - JOINT</span>'

      return
    }
    if (drop.clientTypeId == 3) {
      this.HeaderInfo = 'Non-Individual Client Information'
      this.Tr1 = false
      this.mask = '###-##-####'
      this.profileForm.get('TaxIdmaskId').setValue(1)
      this.displayInfo = true
      this.FirstNamecompany = 'Company Name:'
      this.setLastNameRequired(false)
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">AMERICAN COMPANY INC - CORP</span>'

      return
    }
    if (drop.clientTypeId == 4) {
      this.HeaderInfo = 'Account Information'
      this.secondaryheader = 'Custodian Information'
      return
    }
    if (drop.clientTypeId == 5) {
      this.HeaderInfo = 'Minor Information'
      this.secondaryheader = 'Copy Minor Info Address to Custodian Address'
      this.displaysecondaryck = false
      this.Msecondary = true
      this.secondarymainheader = 'Custodian Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A CF JANE DOE - UTMA</span>'

      // Email is not required for clientTypeId 5
      this.profileForm.get('EmailAddress').setValidators(
        Validators.compose([
          Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'),
        ])
      );
      this.profileForm.get('EmailAddress').updateValueAndValidity();

      return
    }
    if (drop.clientTypeId == 22) {
      this.displaytext =
        '<b class="textdisplay">Format: </b> <span class="textsettings">DOE, JOHN A. - IRA </span>'

      return
    }
    if (drop.clientTypeId == 6) {
      this.secondarymainheader = 'Beneficiary Information'
      this.secondaryheader = 'Copy Account Address to Beneficiary Address'
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.HeaderInfo = 'Account Information'
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A FBO JANE DOE - 529</span>'
      return
    }
    if (drop.clientTypeId == 7) {
      this.displaysecondaryck = false
      this.displayInfo = true
      this.Msecondary = true
      this.HeaderInfo = 'Employer Information'
      this.FirstNamecompany = 'Company Name:'
      this.setLastNameRequired(false)
      this.secondarymainheader = 'Employee Information'
      this.secondaryheader = 'Copy Account Address to Employer Address'
      this.Tr1 = true
      this.hideclientreplist = true
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">AMERICAN & ASSOCIATES 401K PLAN - 401K</span>'
      /*  if (RepList.SelectedValue.Length > 0 || Session["Role"].ToString() == "REP") {
              secondaryClient1Row.Style.Clear();
              secondaryClient2Row.Style.Clear();
            }
            SetSecondaryRequiredVariables(true); */
      return
    }
    if (drop.clientTypeId === 8) {
      this.displaysecondaryck = true
      this.HeaderInfo = 'Trust information'
      this.secondaryheader = 'Copy Trust information to Trustee information'
      this.secondarymainheader = 'Trustee information'
      this.Tr1 = true
      this.displaysecondaryck = false
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.hideclientreplist = true
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">JOHN DOE TRUST DTD 1/14/98, JOHN DOE TTEE - TRUST</span>'
      return
    }
    if (drop.clientTypeId === 22) {
      this.displaytext =
        '<b class="textdisplay">Format: </b> <span class="textsettings">DOE, JOHN A. - IRA </span>'

      return
    }
    if (drop.clientTypeId === 23) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - ROTH</span>'

      return
    }
    if (drop.clientTypeId === 24) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - SIMPLE</span>'

      return
    }
    if (drop.clientTypeId === 25) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - SEP</span>'
      return
    }
    if (drop.clientTypeId === 33) {
      this.HeaderInfo = 'Account Information'
      this.secondaryheader = ''
      this.secondarymainheader = 'Beneficiary Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.displaysecondaryck = false
      this.secondaryheader = 'Beneficiary Information'
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A CF JANE DOE - ESA</span>'
      return
    }
    if (drop.clientTypeId === 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - INDV 401K</span>'
      return
    }
    if (drop.clientTypeId === 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">test </span>'

      return
    }
    if (drop.clientTypeId === 46) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - 403B</span>'
      return
    }
    if (drop.clientTypeId === 52) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN - BEN ROTH IRA</span>'
      return
    }
    if (drop.clientTypeDesc !== '') {
      setTimeout(() => this.getreturn3(), 1000)
      return
    } else {
      setTimeout(() => this.getreturn4(), 1000)
      return
    }
  }
  public selectionChange2(drop: any) {
    if (drop !== null) {
      this.mask = drop.mask
    }
  }
  public toggleAccountInfo() {
    this.accountInfoExpanded = !this.accountInfoExpanded
  }

  public onFocus(combo) {
    if (!combo.isOpen) {
      combo.toggle(true)
    }

    if (combo._text !== '') {
      setTimeout(() => this.getreturn2(), 500)
      return
    } else {
      setTimeout(() => this.getreturn(), 500)
      return
    }
  }
  public onFocus2(combo2) {
    combo2.toggle(true)
  }
  private checkontaxIdexists(d: any) {
    this.checkTxId = true;
    this.showtaxinfo = false;
    this.TxIdGood = false;
    this.TxIdExist = false;
    
    const clientTypeId = this.profileForm.value.ClientTypeId;
    
    if (!clientTypeId) {
      this.showToast('warning', 'Please select an Account Type first')
      this.checkTxId = false;
      return;
    }
    
    const param = {
      TaxId: d,
      ClientTypeID: clientTypeId,
    }

    this.serv.CheckTxdreturnstrings(param).subscribe((result: any) => {
      if (result.length !== 0) {
      this.headtitlePopup = result[0]
      }
    })
    this.serv.CheckdatabasedOffTaxId(param).subscribe((result: any) => {
      this.taxList = result
      if (this.isSoftDupType()) {
        this.primaryDupMatches = this.excludeCurrent(result)
        this.showtaxinfo = false
        this.TxIdExist = false
        this.submitdisable = false
        this.checkTxId = false
        this.TxIdGood = this.primaryDupMatches.length === 0
        this.style3 = false
        this.style4 = this.primaryDupMatches.length === 0
        return
      }
      if (Array.isArray(result) && result.length === 0) {
        this.showtaxinfo = false
        if (this.headtitlePopup && this.headtitlePopup !== '') {
        this.showToast('warning', this.headtitlePopup)
        }
        this.submitdisable = true;
        this.TxIdGood = true;
        this.checkTxId = false;
        this.style4 = true;
        this.TxIdExist = false;
        return;
      }
      this.submitdisable = false;
      this.showtaxinfo = true
      this.TxIdExist = true;
      this.checkTxId = false;
      this.style3 = true;
      this.style4 = false;
      return;

    })
  }
  public onDropdownlistFocus() {
    if (
      this.inputControlDropdownlist != null &&
      this.inputControlDropdownlist != undefined
    ) {
      setTimeout(() => {
        if (!this.inputControlDropdownlist.isOpen) {
          this.inputControlDropdownlist.toggle(true)
        }
      }, 200)
    }
  }
  GetrepList() {
    this.loader = true
    //  const param = {}
    this.serv.getreplist().subscribe((result: any) => {
      this.listItems = result
      this.loader = false
      this.listItems.map((reping) => {
        if (reping.lastName) {
          reping.lastName = reping.lastName + ', ' + reping.firstName // + ' ' + reping.repCode
          this.loader = false
          this.openEvent.emit()
        }
      })
    })
  }
  getAccountType() {
    // this.selectedValue = 2;
    this.loaderType = true
    this.loaderstatelist = true
    this.investloading = true
    this.investobjloading = true
    this.serv.getClienttypeList().subscribe((result: any) => {
      this.listClientTypes = result
      this.loaderType = false
    })

  }
  GetActiveStatesList() {
    this.typ.getActiveTypeStatelist().subscribe((r: any) => {
      this.listStates = r
      this.loaderstatelist = false
      this.GetInvestmentProfileTypes()
    })
  }
  GetInvestmentProfileTypes() {
    this.typ.getInvestmentTypelist().subscribe((r: any) => {
      this.InvestObjLists = r
      this.investloading = false
      this.GetInvestmentObjectTypes()
    })
  }
  GetInvestmentObjectTypes() {
    this.typ.getInvestmentObjectlist().subscribe((r: any) => {
      this.InvestObjnwewLists = r
      this.investobjloading = false
      // this.GetLiquidTypes()
    })
  }
  GetLiquidTypes() {
    this.typ.getLiquidObjectlist().subscribe((r: any) => {
      this.LiquidityNeedsLists = r
      this.liqquidloading = false
    })
  }
  GetTimeZoneTypes() {
    this.typ.gettimeZoneObjectlist().subscribe((r: any) => {
      this.TimeHorizonLists = r
      this.timezoneloading = false
    })
  }

  public detectchange2(detect: any) {
    const taxIdValue = detect.value?.trim() || '';
    
    if (taxIdValue !== '') {
      this.checkontaxIdexists(taxIdValue);
    } else {
      // Clear all flags when Tax ID is empty
      this.style3 = false;
      this.style4 = false;
      this.TxIdExist = false;
      this.TxIdGood = false;
      this.showtaxinfo = false;
      this.submitdisable = false;
    }
  }
  /*   private checkontaxIdexists2(d: any) {
      const myvalue = this.profileForm.value;
      const param = { TaxId: d, ClientTypeID: myvalue.ClientTypeList };

      this.serv.CheckTxdreturnstrings(param).subscribe((result: any) => {
        this.headtitlePopup = (result[0]);

      });
      this.serv.CheckdatabasedOffTaxId(param).subscribe((result: any) => {
        this.taxList = (result);
        if (result.length > 0) {
          this.showtaxinfo = true;
          this.showToast('warning', this.headtitlePopup, 'bottom-right');
        }
      });
    } */
  /*   public detectchangeZip2() {
      this.zipcodestring = null;
    } */
  /*   public detectchangeZip(detect: any) {
      const getvalue = detect.value.trim();
      if (getvalue.length === 5) {
        this.zipcodestring = this.zipcodelist[0];
      } else {
        this.zipcodestring = this.zipcodelist[1];
      }
    } */
  GetMaskList() {
    this.typ.getMaskObjectlist().subscribe((r: any) => {
      this.masklistlisting = r
    })
  }

  Includemsg(response: any) {
    if (this.advisorrole === true) {
      if (response !== null) {
        setTimeout(() => {
          this.showToast(
            'primary',
            `Please wait!, You are being redirected!`,
          )
        }, 3000)
      }
    }
  }
  showNextMsg(response: any) {
    if (this.advisorrole === true) {
      if (response !== null) {
        const paramvalue = response.toString()
        const paramT = CryptoJS.AES.encrypt(paramvalue, this.encPassword).toString();

        this.router.navigate(['pages/advisors/AdvisorClients'], {
          queryParams: { ClientId: paramT },
        })
      }
      return
    }
  }
  onGetMessage() {
    this.showToast('success', `Account updated!`)
    // void this.accountListCache.clear()
  }
  returnToTransaction() {
    const url = this.returnTransactionUrl
    // Clear once used so the link is not reused on subsequent visits.
    this.returnTransactionUrl = null
    sessionStorage.removeItem('returnToTransactionUrl')
    if (url) {
      const origin = window.location.origin
      const relativeUrl = url.startsWith(origin) ? url.substring(origin.length) : url
      this.router.navigateByUrl(relativeUrl)
    }
  }
  onGetMessageNext(response: any) {
    console.log('myresponse=' + JSON.stringify(response))
    // If we arrived from a transaction (AccountName link), return to that transaction
    // and skip the default navigation to the account list.
    if (this.returnTransactionUrl) {
      this.returnToTransaction()
      return
    }
    const getAdvisorClient = this.profileForm.get('AdvisorClient').value
    if (this.route.snapshot.queryParams['Cld']) {
      this.route.queryParams.subscribe((params) => {
        this.getClientId = Number(params['Cld'])
        this.profileForm.get('ClientId').setValue(this.getClientId)
      })
    }
    this.paramValueinsert = this.getClientId
    if (this.getClientId === undefined) {
      this.getClientId = Number(response)
      this.profileForm.get('ClientId').setValue(Number(response))
      this.paramValueinsert = Number(response)
    }

    if (!this.addTransactionAfterSubmit) {
      if (getAdvisorClient) {
        const paramT = CryptoJS.AES.encrypt(
          encodeURI(this.paramValueinsert.toString()).trim(),
          this.encPassword.trim(),
        ).toString()
        this.router.navigate(['pages/advisors/AdvisorClients'], {
          queryParams: { ClientId: paramT },
        })
        return
      } else {
       
        const paramT = CryptoJS.AES.encrypt(
          encodeURI(this.paramValueinsert.toString()).trim(),
          this.encPassword.trim(),
        ).toString()
        this.router.navigate(['pages/viewaccounts/view-accounts']);
       /*  this.router.navigate(['pages/viewaccounts/view-accounts'], {
          queryParams: { AccountN: paramT },
        }) */
        return
      }
    }
  }

  onSubmit(skipTaxCheck: boolean = false, Active: boolean) {
    const PauseEachLine = of(null);
    const repSignature = this.profileForm.value.RepSignature;
    repSignature?.replace(/['"]+/g, '') ?? '';

    if (this.profileForm.value.AdvisorClient !== null) {
      this.boolValue = /true/i.test(this.profileForm.value.AdvisorClient);
    }

    if (this.profileForm.value.ClientId === null) {
      this.profileForm.get('ClientId').setValue(0);
    }

    const getAdvisorClient = this.profileForm.get('AdvisorClient').value;
    if (getAdvisorClient === 'false') {
      this.profileForm.get('AdvisorClient').setValue(false);
    }
    if (getAdvisorClient === 'true') {
      this.profileForm.value.AdvisorClient = true;
    }
    this.submitdisable = false;
    if (!this.Rolerep) {
      // When acting as a rep ensure RepId is bound from stored rep id
      this.profileForm.get('RepId').setValue(Number(localStorage.getItem('rpd')));
    }
    this.profileForm.value.AccountOpen = Active

/*     this.profileForm.value.SecondaryEmail = this.profileForm.value.SecondaryEmailAddress ?? '';
    this.profileForm.value.HomePhone = this.profileForm.value.SecondaryMobile ?? '';
     this.profileForm.value.CellPhone = this.profileForm.value.SecondaryMobile ?? ''; */
    const Params = {
      clientInfo: this.profileForm.value,
      rolename: this.roleString,
      advisorflag: this.boolValue,
      ClientNoteId: this.profileForm.get('ClientNoteId').value,
      Active: Active,
      reasonId: this.selectedReasonId ?? 0  // fallback to 0 if null or undefined
    };
    if (skipTaxCheck === true) {
      this.submitClientData(PauseEachLine, Params);
      return;
    }
    const param = {
      TaxId: this.profileForm.value.TaxId,
      ClientTypeID: this.profileForm.value.ClientTypeId,
    };

    if (this.isSoftDupType()) {
      this.checkSoftDuplicatesThenSubmit(param, PauseEachLine, Params, Active);
      return;
    }

    this.serv.CheckdatabasedOffTaxId(param).subscribe((result: any) => {
      this.taxList = result;
      const hasValidData =
        Array.isArray(result) &&
        result.length > 0 &&
        result.some(item => Array.isArray(item) ? item.length > 0 : !!item);

      if (hasValidData) {
        this.showtaxinfo = true;
        this.showToast('danger', 'Tax Id and Account Type exists you cannot continue. Please go to view accounts');
        this.submitdisable = true;
        this.TxIdGood = false;
        this.checkTxId = false;
        return;
      }

      this.submitdisable = false;
      this.showtaxinfo = false;
      this.TxIdExist = true;
      this.checkTxId = false;

      this.submitClientData(PauseEachLine, Params);
    });
  }

  get invalidControlNames(): string[] {
    return Object.keys(this.profileForm.controls)
      .filter(key => this.profileForm.get(key)?.invalid)
      // Non-individual accounts hide Middle/Last Name and use FirstName as Company Name
      .filter(key => !(this.displayInfo && (key === 'LastName' || key === 'MiddleName')))
      .map(key => {
        if (key === 'FirstName') {
          return this.displayInfo ? 'Company Name' : 'First Name'
        }
        if (key === 'LastName') {
          return 'Last Name'
        }
        return key
      });
  }

  // Last Name is hidden (not applicable) for Non-individual account types
  setLastNameRequired(required: boolean) {
    const lastName = this.profileForm.get('LastName')
    if (!lastName) {
      return
    }
    if (required) {
      lastName.setValidators(Validators.required)
    } else {
      lastName.clearValidators()
    }
    lastName.updateValueAndValidity()
  }

  onUpdate() {
    const PauseEachLine = of(null);
    const repSignature = this.profileForm.value.RepSignature;
    repSignature?.replace(/['"]+/g, '') ?? '';

    if (this.profileForm.value.AdvisorClient !== null) {
      this.boolValue = /true/i.test(this.profileForm.value.AdvisorClient);
    }

    if (this.profileForm.value.ClientId === null) {
      this.profileForm.get('ClientId').setValue(0);
    }

    const getAdvisorClient = this.profileForm.get('AdvisorClient').value;
    if (getAdvisorClient === 'false') {
      this.profileForm.get('AdvisorClient').setValue(false);
    }
    if (getAdvisorClient === 'true') {
      this.profileForm.value.AdvisorClient = true;
    }

    this.submitdisable = false;

    if (this.Rolerep) {
      // When acting as a rep ensure RepId is bound from stored rep id
     // this.profileForm.get('RepId').setValue(Number(localStorage.getItem('rpd')));
    }

    const Params = {
      clientInfo: this.profileForm.value,
      rolename: this.roleString,
      advisorflag: this.boolValue,
      ClientNoteId: this.profileForm.get('ClientNoteId').value,
    };

    this.submitClientData(PauseEachLine, Params);
    return;

  }
  private submitClientData(PauseEachLine: any, Params: any) {
    this.typ
      .submitClientInfo(Params)
      .pipe(
        tap((response: any) => {
          this.onGetMessage();
        }),
        delay(3000),
        tap((response: any) => {
          this.onGetMessageNext(response);
        }),
        catchError(err => {
          console.error('[submitClientInfo] error:', err);
          this.showToast('danger', 'Submission failed. Please try again.');
          return EMPTY;
        })
      )
      .subscribe();
  }
  private isValidSubmitResponse(response: any): boolean {
    if (!response) return false;
    if (typeof response === 'number' && response > 0) return true;
    if (Array.isArray(response) && response.length > 0) return true;
    if (response && typeof response === 'object') {
      if ('clientId' in response && Number(response.clientId) > 0) return true;
      if ('id' in response && Number(response.id) > 0) return true;
    }
    return false;
  }
  // Optionally normalize the response to an ID (can be used later if needed)
  private extractInsertedId(response: any): number | null {
    if (!response) return null;
    if (typeof response === 'number') return response;
    if (Array.isArray(response) && response.length) {
      const first = response[0];
      if (typeof first === 'number') return first;
      if (first?.clientId) return Number(first.clientId);
      if (first?.id) return Number(first.id);
    }
    if (response?.clientId) return Number(response.clientId);
    if (response?.id) return Number(response.id);
    return null;
  }
  public openClose(): void {
    this.showtaxinfo = false
  }

  // ---------------------------------------------------------------------------
  // Soft duplicate warning (529 / UTMA-UGMA only)
  // ---------------------------------------------------------------------------

  isSoftDupType(): boolean {
    return this.softDupTypes.includes(Number(this.profileForm?.value?.ClientTypeId))
  }

  /** "beneficiary" for 529, "custodian" for UTMA/UGMA. */
  get secondaryPartyLabel(): string {
    return Number(this.profileForm?.value?.ClientTypeId) === 5 ? 'custodian' : 'beneficiary'
  }

  accountTypeLabel(clientTypeId: number): string {
    return Number(clientTypeId) === 5 ? 'UTMA/UGMA' : Number(clientTypeId) === 6 ? '529' : ''
  }

  /** Open the existing account in a new tab so the form being filled in isn't lost. */
  openExistingAccount(clientId: number): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/pages/AccountForm/edit-account'], { queryParams: { Cld: clientId } })
    )
    window.open(url, '_blank', 'noopener')
  }

  /** Blur on the Beneficiary (529) / Custodian (UTMA/UGMA) Tax ID. */
  onSecondaryTaxIdBlur(detect: any): void {
    if (!this.isSoftDupType()) {
      this.detectchange2(detect)
      return
    }
    const taxId = (detect?.value ?? '').toString().trim()
    if (taxId === '') {
      this.secondaryDupMatches = []
      return
    }
    this.serv
      .CheckSecondaryTaxId({ TaxId: taxId, ClientTypeID: Number(this.profileForm.value.ClientTypeId), ClientId: this.currentClientId() })
      .pipe(catchError(() => of([])))
      .subscribe((result: any) => {
        this.secondaryDupMatches = Array.isArray(result) ? result : []
      })
  }

  /** "Save anyway" from the duplicate dialog. */
  confirmSaveAnyway(): void {
    this.showDupDialog = false
    this.onSubmit(true, this.pendingSubmitActive)
  }

  closeDupDialog(): void {
    this.showDupDialog = false
  }

  private clearSoftDupState(): void {
    this.primaryDupMatches = []
    this.secondaryDupMatches = []
    this.showDupDialog = false
  }

  private currentClientId(): number {
    return Number(this.profileForm?.value?.ClientId) || 0
  }

  private excludeCurrent(result: any): any[] {
    const current = this.currentClientId()
    return (Array.isArray(result) ? result : []).filter((m: any) => m && Number(m.clientID) !== current)
  }

  /**
   * 529 / UTMA-UGMA save: check the account owner/minor Tax ID and the
   * beneficiary/custodian Tax ID. Matches only produce a warning dialog with a
   * "Save anyway" option; nothing here blocks the save.
   */
  private checkSoftDuplicatesThenSubmit(param: any, pause: any, params: any, active: boolean): void {
    const secondaryTaxId = (this.profileForm.value.SecondaryTaxID ?? '').toString().trim()
    forkJoin({
      primary: param.TaxId
        ? this.serv.CheckdatabasedOffTaxId(param).pipe(catchError(() => of([])))
        : of([]),
      secondary: secondaryTaxId
        ? this.serv
            .CheckSecondaryTaxId({ TaxId: secondaryTaxId, ClientTypeID: Number(param.ClientTypeID), ClientId: this.currentClientId() })
            .pipe(catchError(() => of([])))
        : of([]),
    }).subscribe(({ primary, secondary }) => {
      this.primaryDupMatches = this.excludeCurrent(primary)
      this.secondaryDupMatches = Array.isArray(secondary) ? secondary : []
      this.showtaxinfo = false
      this.TxIdExist = false
      this.submitdisable = false
      this.checkTxId = false

      if (this.primaryDupMatches.length === 0 && this.secondaryDupMatches.length === 0) {
        this.submitClientData(pause, params)
        return
      }
      this.pendingSubmitActive = active
      this.showDupDialog = true
    })
  }
  public FilterAddAccountScreen(t: string, l: string): void {
    const paramT = CryptoJS.AES.encrypt(
      encodeURI(t).trim(),
      this.encPassword.trim(),
    ).toString()
    const paramL = CryptoJS.AES.encrypt(
      encodeURI(l).trim(),
      this.encPassword.trim(),
    ).toString()
    this.router.navigate(['pages/viewaccounts/view-accounts'], {
      queryParams: { existingTaxId: paramT, myLast: paramL },
    })
  }
  showToast(status: NebularStatus, message: string) {
    // Map Nebular statuses to ngx-toastr methods
    switch (status) {
      case 'success':
        this.toastr.success(message, 'Success');
        break;
      case 'info':
      case 'primary':
        this.toastr.info(message, 'Info');
        break;
      case 'warning':
        this.toastr.warning(message, 'Warning');
        break;
      case 'danger':
        this.toastr.error(message, 'Error');
        break;
      default:
        this.toastr.show(message);
        break;
    }
  }
  /*   showToast(status: NbComponentStatus, message: string, position) {
      this.toastrService.show(message, status, { status, position, icon: '' })
    }
   */
  Lookuprecord() {
    // this.lk.CheckAddress(this.str, this.cit, this.sta, this.zip).subscribe()
  }
  public selectclientsecond(event: any) {
    this.EditTransactionsubForm(event['clientId'])
    //    this.getAccountComments(event['clientId'])
  }
  // selected client info
  selectclientbyClientId(c: number) {
    this.EditClientbelowTransactionStartMethod(c['clientId'])
    // this.getAccountComments(c['clientId'])
  }
  // Custodian Information //
  EditTransactionsubForm(clientId: number) {
    const param = { ClientId: clientId, Edit: 1 }
    this.lk.getAccountInfofromviewAccount(param).subscribe((r: any) => {
      this.profileForm.get('SecondaryFirstName').setValue(r[0].firstName)
      this.profileForm.get('SecondaryMiddleName').setValue(r[0].middleName)
      this.profileForm.get('SecondaryLastName').setValue(r[0].lastName)
      this.profileForm.get('SecondaryEmail').setValue(r[0].SecondaryEmail)
       this.profileForm.get('SecondaryMobile').setValue(toPhoneDigits(r[0].SecondaryMobile))
      this.profileForm.get('SecondaryTaxID').setValue(r[0].taxId)
      if (r[0].dob) {
        this.focusedDOBDatesecond = this.valuesDOB
        const strdov: Date[] = r[0].dob
        this.valuesDOB = new Date(strdov.toString())
        this.profileForm.get('SecondaryDOB').setValue(this.valuesDOB)
        this.focusedDOBDatesecond = this.valuesDOB
        this.calculateSecondaryAge(this.valuesDOB)
      }
      this.profileForm.get('SecondaryAddress1').setValue(r[0].secondaryAddress1)
      this.profileForm.get('SecondaryAddress2').setValue(r[0].secondaryAddress2)
      this.profileForm.get('SecondaryCity').setValue(r[0].secondaryCity)
      this.profileForm.get('SecondaryState').setValue(r[0].secondaryState)
      this.profileForm.get('SecondaryZipCode').setValue(r[0].secondaryZipCode)
    })
  }
  // Account Comments retrieve only
  getAccountComments(clientId: number) {
    const param = { ClientId: clientId }
    this.lk.getClientAccountNotes(param).subscribe((r: any) => {
      if (r.length == 0) {
        return
      }
      this.profileForm.get('Comment').setValue(r[0].note)
      this.profileForm.get('ClientNoteId').setValue(r[0].clientNoteId)
    })
  }
  EditClientbelowTransactionStartMethod(clientId: number) {
    const param = { ClientId: clientId, Edit: 1 }
    this.lk.getAccountInfofromviewAccount(param).subscribe((r: any) => {
      this.editaccountlist = r
      //  this.profileForm.get('RepId').setValue(r[0].repId)
      /* if (r[0].advisorClient != null) {
        this.profileForm
          .get('AdvisorClient')
          .setValue(r[0].advisorClient.toString())
      } */
      // this.profileForm.get('ClientTypeId').setValue(r[0].clientTypeId)
      /* if (r[0].taxId != null) {
        this.profileForm.get('TaxId').setValue(r[0].taxId)
      } */
      /*   if (r[0].taxIdmaskId != null) {
        this.profileForm.get('TaxIdmaskId').setValue(r[0].taxIdmaskId)
      } */
      // this.profileForm.get('AccountName').setValue(r[0].accountName)
      this.profileForm.get('FirstName').setValue(r[0].firstName)
      this.profileForm.get('MiddleName').setValue(r[0].middleName)
      this.profileForm.get('LastName').setValue(r[0].lastName)
      if (r[0].dob) {
        this.focusedDOBDate = this.valuesDOB
        const strdov: Date[] = r[0].dob
        this.valuesDOB = new Date(strdov.toString())
        this.profileForm.get('DOB').setValue(this.valuesDOB)
        this.focusedDOBDate = this.valuesDOB
        this.calculatePrimaryAge(this.valuesDOB)
      }
      this.profileForm.get('Address1').setValue(r[0].address1)
      this.profileForm.get('Address2').setValue(r[0].address2)
      this.profileForm.get('City').setValue(r[0].city)
      this.profileForm.get('State').setValue(r[0].state)
      this.profileForm.get('ZipCode').setValue(r[0].zipCode)
      this.profileForm.get('EmailAddress').setValue(r[0].emailAddress)
      this.profileForm.get('AssociatedPerson').setValue(r[0].associatedPerson)
      this.profileForm.get('AssociatedAccount').setValue(r[0].associatedAccount)
      this.profileForm.get('AccountOpen').setValue(r[0].accountOpen)
      this.profileForm.get('CopyOfDl').setValue(r[0].copyOfDl)
      this.profileForm.get('Mobile').setValue(toPhoneDigits(r[0].mobile))
      this.profileForm.get('NewAccountForm').setValue(r[0].newAccountForm)
      if (r[0].repSignature) {
        this.profileForm.get('RepSignature').setValue('true')
      } else {
        this.profileForm.get('RepSignature').setValue('false')
      }
      this.profileForm
        .get('SecondaryFirstName')
        .setValue(r[0].secondaryFirstName)
      if (r[0].dateOfNewAccountForm) {
        const str: Date[] = r[0].dateOfNewAccountForm
        this.values = new Date(str.toString())
        this.profileForm.get('DateOfNewAccountForm').setValue(this.values)
        this.focusedDateAccountform = this.values
      }
      if (r[0].maturityDate) {
        const strsecondarmature: Date[] = r[0].maturityDate
        this.valuessecondarymature = new Date(strsecondarmature.toString())
        this.profileForm
          .get('MaturityDate')
          .setValue(this.valuessecondarymature)
      }
      if (r[0].repSignature) {
        this.profileForm
          .get('cbCopyToSecondary')
          .setValue(r[0].cbCopyToSecondary)
      }
      this.profileForm
        .get('SecondaryMiddleName')
        .setValue(r[0].secondaryMiddleName)
      this.profileForm.get('SecondaryLastName').setValue(r[0].secondaryLastName)
      if (r[0].secondaryTaxId) {
        this.profileForm.get('SecondaryTaxID').setValue(r[0].secondaryTaxId)
      }
this.profileForm
        .get('SecondaryEmail')
        .setValue(r[0].secondaryEmail)
      this.profileForm.get('SecondaryEmail').setValue(r[0].secondaryEmail)
      if (r[0].secondaryMobile) {
        this.profileForm.get('SecondaryMobile').setValue(toPhoneDigits(r[0].secondaryMobile))
      }

      // this.profileForm.get('SecondaryEmail').setValue(r[0].SecondaryEmail)
      if (r[0].secondaryDob) {
        const strsecondar: Date[] = r[0].secondaryDob
        this.valuessecondary = new Date(strsecondar.toString())
        this.profileForm.get('SecondaryDOB').setValue(this.valuessecondary)
        this.calculateSecondaryAge(this.valuessecondary)
      }
      this.profileForm.get('SecondaryAddress1').setValue(r[0].secondaryAddress1)
      this.profileForm.get('SecondaryAddress2').setValue(r[0].secondaryAddress2)
      this.profileForm.get('SecondaryCity').setValue(r[0].secondaryCity)
      this.profileForm.get('SecondaryState').setValue(r[0].secondaryState)
      this.profileForm.get('SecondaryZipCode').setValue(r[0].secondaryZipCode)
      if (r[0].annualIncFrom) {
        this.profileForm.get('AnnualIncFrom').setValue(r[0].annualIncFrom)
      }
      if (r[0].annualIncTo) {
        this.profileForm.get('AnnualIncTo').setValue(r[0].annualIncTo)
      }
      if (r[0].netWorthFrom) {
        this.profileForm.get('NetWorthFrom').setValue(Number(r[0].netWorthFrom))
      }
      if (r[0].netWorthTo) {
        this.profileForm.get('NetWorthTo').setValue(Number(r[0].netWorthTo))
      }
      if (r[0].liquidNWFrom) {
        this.profileForm.get('LiquidNWFrom').setValue(Number(r[0].liquidNWFrom))
      }
      if (r[0].liquidNWTo) {
        this.profileForm.get('LiquidNWTo').setValue(Number(r[0].liquidNWTo))
      }
      if (r[0].investmentProfileId) {
        this.profileForm
          .get('InvestmentProfileId')
          .setValue(r[0].investmentProfileId)
      }
      if (r[0].invObjectiveId) {
        this.profileForm.get('InvObjectiveId').setValue(r[0].invObjectiveId)
      }
      if (r[0].liquidityNeedsId) {
        this.profileForm.get('LiquidityNeedsId').setValue(r[0].liquidityNeedsId)
      }
      //  this.profileForm.get('InvestmentTimeHorizonId').setValue(3);
      if (r[0].investmentTimeHorizonId) {
        this.profileForm
          .get('InvestmentTimeHorizonId')
          .setValue(r[0].investmentTimeHorizonId)
      }
      if (r[0].equitiesExp) {
        this.profileForm.get('EquitiesExp').setValue(r[0].equitiesExp)
      }
      if (r[0].optionsExp) {
        this.profileForm.get('OptionsExp').setValue(r[0].optionsExp)
      }
      if (r[0].fixedIncExp) {
        this.profileForm.get('FixedIncExp').setValue(r[0].fixedIncExp)
      }
      if (r[0].etfexp) {
        this.profileForm.get('Etfexp').setValue(r[0].etfexp)
      }
      if (r[0].uitexp) {
        this.profileForm.get('Uitexp').setValue(r[0].uitexp)
      }
      if (r[0].realEstateExp) {
        this.profileForm.get('RealEstateExp').setValue(r[0].realEstateExp)
      }
      if (r[0].insExp) {
        this.profileForm.get('InsExp').setValue(r[0].insExp)
      }
      if (r[0].vaexp) {
        this.profileForm.get('Vaexp').setValue(r[0].vaexp)
      }
      if (r[0].fixedAnnExp) {
        this.profileForm.get('FixedAnnExp').setValue(r[0].fixedAnnExp)
      }
      if (r[0].precMetExp) {
        this.profileForm.get('PrecMetExp').setValue(r[0].precMetExp)
      }
      if (r[0].mutFundsExp) {
        this.profileForm.get('MutFundsExp').setValue(r[0].mutFundsExp)
      }
      if (r[0].commExp) {
        this.profileForm.get('CommExp').setValue(r[0].commExp)
      }
      if (r[0].otherExp) {
        this.profileForm.get('OtherExp').setValue(r[0].otherExp)
      }
      if (r[0].otherExpDesc) {
        this.profileForm.get('OtherExpDesc').setValue(r[0].otherExpDesc)
      }
      if (r[0].comment) {
        this.profileForm.get('Comment').setValue(r[0].comment)
      }
      this.OnEditshowVerbiagerules()
    })
  }
  // Change the edit below feature. //
  // EDIT ACCOUNTS FUNCTION BELOW //
  EditTransactionStartMethod(clientId: number) {
    const param = { ClientId: clientId, Edit: 1 }
    this.lk.getAccountInfofromviewAccount(param).subscribe((r: any) => {
      this.editaccountlist = r
      this.profileForm.get('RepId').setValue(r[0].repId)
      if (r[0].advisorClient != null) {
        this.profileForm
          .get('AdvisorClient')
          .setValue(r[0].advisorClient.toString())
      }
      this.profileForm.get('ClientTypeId').setValue(r[0].clientTypeId)
      if (r[0].taxId != null) {
        this.profileForm.get('TaxId').setValue(r[0].taxId)
      }
      if (r[0].taxIdmaskId != null) {
        this.profileForm.get('TaxIdmaskId').setValue(r[0].taxIdmaskId)
      }
      this.profileForm.get('AccountName').setValue(r[0].accountName)
      this.profileForm.get('FirstName').setValue(r[0].firstName)
      this.profileForm.get('MiddleName').setValue(r[0].middleName)
      this.profileForm.get('LastName').setValue(r[0].lastName)
      if (r[0].dob) {
        this.focusedDOBDate = this.valuesDOB
        const strdov: Date[] = r[0].dob
        this.valuesDOB = new Date(strdov.toString())
        this.profileForm.get('DOB').setValue(this.valuesDOB)
        this.focusedDOBDate = this.valuesDOB
        this.calculatePrimaryAge(this.valuesDOB)
      }
      this.profileForm.get('Address1').setValue(r[0].address1)
      this.profileForm.get('Address2').setValue(r[0].address2)
      this.profileForm.get('City').setValue(r[0].city)
      this.profileForm.get('State').setValue(r[0].state)
      this.profileForm.get('ZipCode').setValue(r[0].zipCode)
      this.profileForm.get('EmailAddress').setValue(r[0].emailAddress)
      this.profileForm.get('AssociatedPerson').setValue(r[0].associatedPerson)
      this.profileForm.get('AssociatedAccount').setValue(r[0].associatedAccount)
      this.profileForm.get('AccountOpen').setValue(r[0].accountOpen)
      this.profileForm.get('CopyOfDl').setValue(r[0].copyOfDl)
      this.profileForm.get('Mobile').setValue(toPhoneDigits(r[0].mobile))
      this.profileForm.get('NewAccountForm').setValue(r[0].newAccountForm)
      if (r[0].repSignature) {
        this.profileForm.get('RepSignature').setValue('true')
      } else {
        this.profileForm.get('RepSignature').setValue('false')
      }
      this.profileForm
        .get('SecondaryFirstName')
        .setValue(r[0].secondaryFirstName)
      if (r[0].dateOfNewAccountForm) {
        const str: Date[] = r[0].dateOfNewAccountForm
        this.values = new Date(str.toString())
        this.profileForm.get('DateOfNewAccountForm').setValue(this.values)
        this.focusedDateAccountform = this.values
      }
      this.profileForm
        .get('SecondaryEmail')
        .setValue(r[0].secondaryEmail)
      this.profileForm.get('SecondaryEmail').setValue(r[0].secondaryEmail)
      if (r[0].secondaryMobile) {
        this.profileForm.get('SecondaryMobile').setValue(toPhoneDigits(r[0].secondaryMobile))
      }
      if (r[0].maturityDate) {
        const strsecondarmature: Date[] = r[0].maturityDate
        this.valuessecondarymature = new Date(strsecondarmature.toString())
        this.profileForm
          .get('MaturityDate')
          .setValue(this.valuessecondarymature)
      }
      if (r[0].repSignature) {
        this.profileForm
          .get('cbCopyToSecondary')
          .setValue(r[0].cbCopyToSecondary)
      }
      this.profileForm
        .get('SecondaryMiddleName')
        .setValue(r[0].secondaryMiddleName)
      this.profileForm.get('SecondaryLastName').setValue(r[0].secondaryLastName)
      if (r[0].secondaryTaxId) {
        this.profileForm.get('SecondaryTaxID').setValue(r[0].secondaryTaxId)
      }
      if (r[0].secondaryDob) {
        const strsecondar: Date[] = r[0].secondaryDob
        this.valuessecondary = new Date(strsecondar.toString())
        this.profileForm.get('SecondaryDOB').setValue(this.valuessecondary)
        this.calculateSecondaryAge(this.valuessecondary)
      }
      this.profileForm.get('SecondaryAddress1').setValue(r[0].secondaryAddress1)
      this.profileForm.get('SecondaryAddress2').setValue(r[0].secondaryAddress2)
      this.profileForm.get('SecondaryCity').setValue(r[0].secondaryCity)
      this.profileForm.get('SecondaryState').setValue(r[0].secondaryState)
      this.profileForm.get('SecondaryZipCode').setValue(r[0].secondaryZipCode)
      if (r[0].annualIncFrom) {
        this.profileForm.get('AnnualIncFrom').setValue(r[0].annualIncFrom)
      }
      if (r[0].annualIncTo) {
        this.profileForm.get('AnnualIncTo').setValue(r[0].annualIncTo)
      }
      if (r[0].netWorthFrom) {
        this.profileForm.get('NetWorthFrom').setValue(Number(r[0].netWorthFrom))
      }
      if (r[0].netWorthTo) {
        this.profileForm.get('NetWorthTo').setValue(Number(r[0].netWorthTo))
      }
      if (r[0].liquidNWFrom) {
        this.profileForm.get('LiquidNWFrom').setValue(Number(r[0].liquidNWFrom))
      }
      if (r[0].liquidNWTo) {
        this.profileForm.get('LiquidNWTo').setValue(Number(r[0].liquidNWTo))
      }
      if (r[0].investmentProfileId) {
        this.profileForm
          .get('InvestmentProfileId')
          .setValue(r[0].investmentProfileId)
      }
      if (r[0].invObjectiveId) {
        this.profileForm.get('InvObjectiveId').setValue(r[0].invObjectiveId)
      }
      if (r[0].liquidityNeedsId) {
        this.profileForm.get('LiquidityNeedsId').setValue(r[0].liquidityNeedsId)
      }
      //  this.profileForm.get('InvestmentTimeHorizonId').setValue(3);
      if (r[0].investmentTimeHorizonId) {
        this.profileForm
          .get('InvestmentTimeHorizonId')
          .setValue(r[0].investmentTimeHorizonId)
      }
      if (r[0].equitiesExp) {
        this.profileForm.get('EquitiesExp').setValue(r[0].equitiesExp)
      }
      if (r[0].optionsExp) {
        this.profileForm.get('OptionsExp').setValue(r[0].optionsExp)
      }
      if (r[0].fixedIncExp) {
        this.profileForm.get('FixedIncExp').setValue(r[0].fixedIncExp)
      }
      if (r[0].etfexp) {
        this.profileForm.get('Etfexp').setValue(r[0].etfexp)
      }
      if (r[0].uitexp) {
        this.profileForm.get('Uitexp').setValue(r[0].uitexp)
      }
      if (r[0].realEstateExp) {
        this.profileForm.get('RealEstateExp').setValue(r[0].realEstateExp)
      }
      if (r[0].insExp) {
        this.profileForm.get('InsExp').setValue(r[0].insExp)
      }
      if (r[0].vaexp) {
        this.profileForm.get('Vaexp').setValue(r[0].vaexp)
      }
      if (r[0].fixedAnnExp) {
        this.profileForm.get('FixedAnnExp').setValue(r[0].fixedAnnExp)
      }
      if (r[0].precMetExp) {
        this.profileForm.get('PrecMetExp').setValue(r[0].precMetExp)
      }
      if (r[0].mutFundsExp) {
        this.profileForm.get('MutFundsExp').setValue(r[0].mutFundsExp)
      }
      if (r[0].commExp) {
        this.profileForm.get('CommExp').setValue(r[0].commExp)
      }
      if (r[0].otherExp) {
        this.profileForm.get('OtherExp').setValue(r[0].otherExp)
      }
      if (r[0].otherExpDesc) {
        this.profileForm.get('OtherExpDesc').setValue(r[0].otherExpDesc)
      }
      if (r[0].comment) {
        this.profileForm.get('Comment').setValue(r[0].comment)
      }
      this.OnEditshowVerbiagerules()
    })
  }

  OnEditshowVerbiagerules() {
    const drop = this.profileForm.value.ClientTypeId
    if (this.profileForm.value.TaxIdmaskId === null) {
      this.profileForm.get('TaxIdmaskId').setValue(1)
      if (drop === 7 || drop === 8) {
        this.mask = '##-#######'
        this.profileForm.get('TaxIdmaskId').setValue(2)
      } else {
        this.mask = '###-##-####'
        this.profileForm.get('TaxIdmaskId').setValue(1)
      }
    }
    if (drop == 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - INDV 401K</span>'
    }
    if (drop == 1) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - INDV</span>'

      return
    }
    if (drop == 2) {
      this.HeaderInfo = 'Primary Client Information'
      this.secondaryheader =
        'Copy Primary Client Address to Secondary Client Address'
      this.secondarymainheader = 'Secondary Client Information'
      this.Tr1 = true
      this.Msecondary = true
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.displaysecondaryck = false
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN L. & JANE P. - JOINT</span>'

      return
    }
    if (drop == 3) {
      this.HeaderInfo = 'Non-Individual Client Information'
      this.Tr1 = false
      this.mask = '###-##-####'
      this.profileForm.get('TaxIdmaskId').setValue(1)
      this.displayInfo = true
      this.FirstNamecompany = 'Company Name:'
      this.setLastNameRequired(false)
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">AMERICAN COMPANY INC - CORP</span>'

      return
    }
    if (drop == 4) {
      this.HeaderInfo = 'Account Information'
      this.secondaryheader = 'Custodian Information'
      return
    }
    if (drop == 5) {
      this.HeaderInfo = 'Minor Information'
      this.secondaryheader = 'Copy over Minor infomation to Cusodian'
      this.displaysecondaryck = false
      this.secondarymainheader = 'Custodian Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.Msecondary = true
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A CF JANE DOE - UTMA</span>'

      return
    }
    if (drop == 6) {
      this.secondarymainheader = 'Beneficiary Information'
      this.secondaryheader = 'Copy Account Address to Beneficiary Address'
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.displaysecondaryck = true
      this.HeaderInfo = 'Account Information'
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A FBO JANE DOE - 529</span>'
      this.cdr.detectChanges()
      return
    }
    if (drop == 7) {
      this.secondaryheader = 'Copy Account Address to Employee Address'
      this.displaysecondaryck = true
      this.displayInfo = true
      this.FirstNamecompany = 'Company Name:'
      this.HeaderInfo = 'Employer Information'
      this.secondarymainheader = 'Employee Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.setLastNameRequired(false)
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">AMERICAN & ASSOCIATES 401K PLAN - 401K</span>'
      return
    }
    if (drop == 8) {
      this.displaysecondaryck = true
      this.HeaderInfo = 'Trust information'
      this.secondaryheader = ''
      this.secondarymainheader = 'Trustee information'
      this.Tr1 = true
      this.displaysecondaryck = false
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">JOHN DOE TRUST DTD 1/14/98, JOHN DOE TTEE - TRUST</span>'
      return
    }
    if (drop == 22) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - IRA </span>'

      return
    }
    if (drop == 23) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - ROTH</span>'

      return
    }
    if (drop == 24) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">  </span>'

      return
    }
    if (drop == 25) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - SEP</span>'
      return
    }
    if (drop == 33) {
      this.displaysecondaryck = true
      this.HeaderInfo = 'Account Information'
      this.secondaryheader = ''
      this.secondarymainheader = 'Beneficiary Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.accountInfoExpanded = true // Auto-expand when secondary form shows
      this.displaysecondaryck = false
      this.secondaryheader = 'Beneficiary Information'
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A CF JANE DOE - ESA</span>'
      return
    }
    if (drop == 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - INDV 401K</span>'
      return
    }
    if (drop == 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings"> </span>'

      return
    }
    if (drop == 46) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - 403B</span>'
      return
    }
    if (drop == 52) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN - BEN ROTH IRA</span>'
      return
    }
  }
  onDelete() {
    this.openDeleteAccount = true
  }
  deleteAccountUserClosebybutton() {
    this.openDeleteAccount = false
  }
  onOpen() {
    this.openOpenAccount = true
  }
  openAccountUserClosebybutton() {
    this.openOpenAccount = false
  }
  LoadDataAccount() {

    this.serv.getReasonTypeList().subscribe((result: any) => {
      this.dataReasonlist = result;
    })
  }
  onFocus0(dp0: DatePickerComponent) {
    if (!dp0.isOpen) {
      //dp0.toggle(true)
    }
  }
  calculatePrimaryAge(date: Date) {
    this.calculatedPrimaryAge = this.calculateAge(date) + 'yo'
  }
  onFocus1(dp1: DatePickerComponent) {
    this.dateFormActive = true
    this.dateFormPicker = dp1
    if (!dp1.isOpen) {
      dp1.toggle(true)
    }
  }
  onDateFormBlur() {
    this.dateFormActive = false
  }
  // Listens on document so it still fires when focus is inside the calendar popup (rendered in body).
  @HostListener('document:keydown.tab', ['$event'])
  onDateOfAccountFormTab(event: KeyboardEvent) {
    // After Date of Account Form, send focus back up to the Investment Information fields.
    if (!this.dateFormActive || event.shiftKey) {
      return
    }
    event.preventDefault()
    event.stopPropagation()
    this.dateFormActive = false
    this.dateFormPicker?.toggle(false)
    // Defer so the datepicker popup fully closes before we move/scroll focus.
    setTimeout(() => {
      this.annualIncFrom?.focus()
      const target = document.querySelector('[formcontrolname="AnnualIncFrom"]') as HTMLElement | null
      target?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
  }
  onFocus3(dp3: DatePickerComponent) {
    if (!dp3.isOpen) {
      dp3.toggle(true)
    }
  }
  calculateSecondaryAge(date: Date) {
    this.calculatedSecondaryAge = this.calculateAge(date) + 'yo'
  }
  pushCopyData() {
    /* this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('FirstName').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('FirstName').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryFirstName').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryFirstName').reset()

            return EMPTY
          }
        }),
      )
      .subscribe() */
   /*  this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('LastName').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('LastName').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryLastName').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryLastName').reset()

            return EMPTY
          }
        }),
        // don't forget to unsubscribe when component's destroyed
      )
      .subscribe() */
   /*  this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('MiddleName').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('MiddleName').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryMiddleName').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryMiddleName').reset()

            return EMPTY
          }
        }),
        // don't forget to unsubscribe when component's destroyed
      )
      .subscribe() */
  /*   this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('focusedDOBDate').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('focusedDOBDate').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryDOB').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryDOB').reset()

            return EMPTY
          }
        }),
      )
      .subscribe() */
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('Address1').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('Address1').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryAddress1').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryAddress1').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('Address2').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('Address2').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryAddress2').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryAddress2').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
   /*  this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('TaxId').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('TaxId').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryTaxID').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryTaxID').reset()

            return EMPTY
          }
        }),
      )
      .subscribe() */
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('City').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('City').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryCity').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryCity').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('State').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('State').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryState').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryState').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('ZipCode').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('ZipCode').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryZipCode').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryZipCode').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
  }
  calculateAge(date: Date): number {
    const millisecDifference = Date.now() - date.getTime()
    const millisecPerDay = 24 * 60 * 60 * 1000
    const millisecPerYear = 365.25 * millisecPerDay

    const yearDifference = Math.floor(millisecDifference / millisecPerYear)
    return yearDifference
  }
  getInvalidControls() {
    const controls = this.profileForm.controls;
    return Object.keys(controls)
      .filter(key => controls[key].invalid)
      .map(key => ({
        name: key,
        errors: controls[key].errors
      }));
  }

}
